// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1_ilt","cls2":"SuggestionCard-cls2_UYZ SuggestionCard-cls1_ilt","small":"SuggestionCard-small_gm_"};